import { render, staticRenderFns } from "./_store-quantity.modal.vue?vue&type=template&id=2d84bca0&scoped=true"
import script from "./_store-quantity.modal.vue?vue&type=script&lang=js"
export * from "./_store-quantity.modal.vue?vue&type=script&lang=js"
import style0 from "./_store-quantity.modal.vue?vue&type=style&index=0&id=2d84bca0&prod&lang=scss&scoped=true"
import style1 from "./_store-quantity.modal.vue?vue&type=style&index=1&id=2d84bca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84bca0",
  null
  
)

export default component.exports